import { AdjClose, AdjCloseCHG, AdjCloseChange } from "utils/detailAsset";
import { useRouter } from "next/router";
import { TYPO } from "styles/Typo";
import Image from "next/image";
import PriceStatus from "./PriceStatus";
import MonetaryBtn from "components/common/monetaryBtn";
import Link from "next/link";
import useIsDetailLoading from "states/detailLoading";
import { useParams } from "next/navigation";
import { useMemo, useState } from "react";
import { PriceInfoSkeleton } from "components/skeleton/detail";
import { CRYPTO, US } from "utils/constant/ITME_INFO";
import useHandleImageError from "utils/useHandleImageError";
import { useSession } from "next-auth/react";
import { track, trackPageAction } from "lib/analytics/core/client";

function SDHeaderInfo({
  detailData,
  toggleActive,
  setToggleActive,
  isHoliday,
  setSearchModal,
}: {
  detailData: any;
  toggleActive: boolean;
  setToggleActive: any;
  isHoliday?: boolean;
  setSearchModal: any;
}) {
  const router = useRouter();
  const LOC = detailData?.LOC;
  return (
    <div className=" gap-1 justify-between items-center flex">
      <div className="flex flex-col  overflow-hidden gap-2 w-full">
        <div className="flex flex-col">
          <div className="flex flex-col gap-[2px] py-1">
            <div className="flex items-center gap-1">
              <p className={`truncate ${TYPO.TYPO5_1_MD} text-gray80`}>
                {router.locale === "ko"
                  ? detailData?.ITEM_KR_NM && detailData?.ITEM_KR_NM
                  : detailData?.ITEM_ENG_NM && detailData?.ITEM_ENG_NM}
              </p>
              <div
                // href="/search-list"
                onClick={() => {
                  window.dataLayer.push({
                    event: "cDetailSearch",
                  });
                  track("search_open", {
                    search_type: "stock", // 통합검색
                    source: "stock_detail",
                  });
                  setSearchModal(true);
                }}
                className={`cursor-pointer flex items-center ${TYPO.TYPO8_MD} bg-gray5 px-1 py-[2px] rounded-[8px] text-gray40`}
              >
                <span>{detailData?.ITEM_CD_DL && detailData?.ITEM_CD_DL}</span>
                <SearchIcon />
              </div>
            </div>
          </div>
          <div className="flex py-1 justify-between items-center ">
            <div className="flex items-center gap-1">
              <p className={`truncate ${TYPO.TYPO3_MD} text-gray90`}>
                {AdjClose(detailData, router.locale, toggleActive)}
              </p>
              {LOC === US && (
                <p className={`truncate ${TYPO.TYPO7_1_RG} text-gray50`}>
                  {AdjClose(detailData, router.locale, !toggleActive)}
                </p>
              )}
            </div>
            <div
              className={`${
                (router.locale === "ko" && detailData?.CURR === "KRW") ||
                detailData.CAT === "Index" ||
                (router.locale === "en" &&
                  ((detailData?.LOC === US && detailData?.CAT === "Stock") ||
                    detailData?.CAT === CRYPTO))
                  ? "hidden"
                  : ""
              }`}
            >
              <MonetaryBtn
                isActive={toggleActive}
                onClick={() => {
                  trackPageAction("toggle_stock_price");
                }}
                setIsActive={setToggleActive}
                cat={detailData?.CAT}
                loc={detailData?.LOC}
              />
            </div>
          </div>

          <PriceStatus
            detailData={detailData}
            isHoliday={isHoliday}
            toggleActive={toggleActive}
          />
        </div>
        {/* <PriceStatus detailData={detailData} isHoliday={isHoliday} /> */}
      </div>
    </div>
  );
}

function PriceInfo({
  isMobile,
  isHoliday,
  detailData,
  toggleActive,
  setToggleActive,
  setIsRiskModalOpen,
  isHalt,
  setSearchModal,
  stAdvisible,
}: {
  isMobile: boolean;
  isHoliday?: boolean;
  detailData: any;
  toggleActive: boolean;
  setToggleActive: any;
  setIsRiskModalOpen: any;
  isHalt?: boolean;
  setSearchModal: any;
  stAdvisible?: any;
}) {
  const isLoading = useIsDetailLoading();
  const router = useRouter();
  const { data: session }: any = useSession();

  const isInterested = useMemo(() => {
    if (session && session.user) {
      return session.user?.interest.length > 0;
    }
  }, [session, detailData]);

  if (isMobile) {
    return (
      <div
        className={`flex flex-col gap-6 bg-white pb-6 ${
          detailData?.CAT === CRYPTO ? "" : ""
        } `}
      >
        {isLoading && <PriceInfoSkeleton />}
        {!isLoading && (
          <div className="flex pt-4  px-6 flex-col ">
            {isHalt && (
              <div className="mb-5 ">
                <div className="w-fit py-[2px] px-[6px] bg-gray10 rounded-[40px] flex items-center gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <circle cx="8" cy="8" r="8" fill="var(--gray60)" />
                    <path
                      d="M6.92862 5.19317C6.86033 4.55583 7.35979 4 8.00078 4C8.64177 4 9.14123 4.55583 9.07294 5.19317L8.6647 9.00341C8.62835 9.34271 8.34202 9.6 8.00078 9.6C7.65954 9.6 7.37321 9.34271 7.33686 9.00341L6.92862 5.19317Z"
                      fill="white"
                    />
                    <rect
                      x="7.20117"
                      y="10.4004"
                      width="1.6"
                      height="1.6"
                      rx="0.8"
                      fill="white"
                    />
                  </svg>
                  <span className={`${TYPO.TYPO7_MD} text-gray60`}>
                    {router.locale === "ko" ? "거래정지" : "Trading Halt"}
                  </span>
                </div>
              </div>
            )}
            <SDHeaderInfo
              detailData={detailData}
              toggleActive={toggleActive}
              setToggleActive={setToggleActive}
              isHoliday={isHoliday}
              setSearchModal={setSearchModal}
            />
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div
        className={`flex flex-col gap-6  bg-white pb-5 pt-4 ${
          detailData?.CAT === CRYPTO ? "" : ""
        } `}
      >
        {isLoading && (
          <div className={`${isInterested ? "" : ""} `}>
            <PriceInfoSkeleton />
          </div>
        )}
        {!isLoading && (
          <div
            className={`${isInterested ? "" : ""} flex shrink-0  px-6 flex-col`}
          >
            {isHalt && (
              <div className="mb-5 ">
                <div className="w-fit py-[2px] px-[6px] bg-gray10 rounded-[40px] flex items-center gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <circle cx="8" cy="8" r="8" fill="var(--gray60)" />
                    <path
                      d="M6.92862 5.19317C6.86033 4.55583 7.35979 4 8.00078 4C8.64177 4 9.14123 4.55583 9.07294 5.19317L8.6647 9.00341C8.62835 9.34271 8.34202 9.6 8.00078 9.6C7.65954 9.6 7.37321 9.34271 7.33686 9.00341L6.92862 5.19317Z"
                      fill="white"
                    />
                    <rect
                      x="7.20117"
                      y="10.4004"
                      width="1.6"
                      height="1.6"
                      rx="0.8"
                      fill="white"
                    />
                  </svg>
                  <span className={`${TYPO.TYPO7_MD} text-gray60`}>
                    {router.locale === "ko" ? "거래정지" : "Trading Halt"}
                  </span>
                </div>
              </div>
            )}
            <SDHeaderInfo
              detailData={detailData}
              toggleActive={toggleActive}
              setToggleActive={setToggleActive}
              isHoliday={isHoliday}
              setSearchModal={setSearchModal}
            />
          </div>
        )}
      </div>
    );
  }
}
const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.89879 10.8427C9.14468 11.4025 8.21069 11.7337 7.19935 11.7337C4.69566 11.7337 2.66602 9.70402 2.66602 7.20033C2.66602 4.69663 4.69566 2.66699 7.19935 2.66699C9.70304 2.66699 11.7327 4.69663 11.7327 7.20033C11.7327 8.21172 11.4015 9.14575 10.8416 9.89988L13.2763 12.3345C13.5366 12.5949 13.5366 13.017 13.2763 13.2773C13.0159 13.5377 12.5938 13.5377 12.3334 13.2773L9.89879 10.8427ZM10.3993 7.20033C10.3993 8.96764 8.96666 10.4003 7.19935 10.4003C5.43204 10.4003 3.99935 8.96764 3.99935 7.20033C3.99935 5.43301 5.43204 4.00033 7.19935 4.00033C8.96666 4.00033 10.3993 5.43301 10.3993 7.20033Z"
        fill="var(--gray40)"
      />
    </svg>
  );
};

export default PriceInfo;
